import { ROUTE } from '../../App';
import Button from '../../components/Buttons/Button';
import cn from '../../lib/classNames';

import laptop from './images/businessEditionUnlockLaptop.svg';

import styles from './BusinessEditionUnlock.module.scss';

type BusinessEditionUnlockType = {
	classPageContent?: string;
};

export default function BusinessEditionUnlock(props: BusinessEditionUnlockType) {
	const { classPageContent } = props;
	return (
		<div className={styles.wrap}>
			<div className={cn(styles.content, classPageContent)}>
				<div className={styles['text-block']}>
					<h3 className={styles.title}>Business Edition: Unlock Advanced Business Tools</h3>
					<div className={styles.description}>
						Empower your team with advanced analytics, seamless collaboration, and tailored
						solutions for your company’s unique needs. Scale smarter with tools designed for
						businesses of any size.
					</div>
					<div className={styles['button-wrap']}>
						<Button
							className={styles.button}
							variant="filled"
							elementType="navigate"
							color="primary"
							size="large"
							href={ROUTE.businessEditionPage}
							target="_blank"
						>
							Learn more
						</Button>
					</div>
				</div>
				<div className={styles.image}>
					<img src={laptop} alt="Business Edition: Unlock Advanced Business Tools" />
				</div>
			</div>
		</div>
	);
}
